module.exports = __webpack_public_path__ + "static/media/chart@3x.1ed743f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/chart@3x.png
// module id = 759
// module chunks = 0